import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import HImage from "@cloudpivot/form/src/common/components/image.vue";
let ImageDesign = class ImageDesign extends Vue {
    render(h) {
        return h('h-image', { props: {
                disabled: true,
                text: "点击或拖拽上传"
            } });
    }
};
tslib_1.__decorate([
    Prop()
], ImageDesign.prototype, "control", void 0);
ImageDesign = tslib_1.__decorate([
    Component({ name: 'ImageDesign', components: { HImage } })
], ImageDesign);
export default ImageDesign;
